var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmallArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-location 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.53203 8.92183C7.2842 9.16847 7.2842 9.56837 7.53203 9.81502C7.77986 10.0617 8.18168 10.0617 8.42951 9.81502L11.8141 6.44659C11.938 6.32327 12 6.16164 12 6C12 5.91436 11.9829 5.83271 11.9518 5.75824C11.9209 5.68375 11.875 5.61396 11.8141 5.55341L8.42951 2.18498C8.18168 1.93834 7.77986 1.93834 7.53203 2.18499C7.2842 2.43163 7.2842 2.83153 7.53203 3.07817L9.83329 5.36842L1.63462 5.36842C1.28413 5.36842 1 5.65119 1 6C1 6.34881 1.28413 6.63158 1.63462 6.63158L9.83329 6.63158L7.53203 8.92183Z",
    fill: "#735BF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallArrowRight);
export default __webpack_public_path__ + "static/media/iconSmallArrowRight.7a41588c93292a35fe8a74c698024652.svg";
export { ForwardRef as ReactComponent };